import React from "react";
import { MenuItem } from "@chakra-ui/react";
import { IoTrashOutline } from "react-icons/io5";
import { Modal } from "components";
import { GetUsersDocument, useDeleteUserMutation } from "requests";

interface DeleteProps {
  _id: number;
  fullName: string;
  onSuccess(): Promise<any>;
}

const Delete: React.FC<DeleteProps> = ({ _id, fullName, onSuccess }) => {
  const [deleteUser] = useDeleteUserMutation();

  return (
    <>
      <Modal.Confirm
        onConfirm={() =>
          deleteUser({
            variables: { input: { _id } },
            refetchQueries: [GetUsersDocument]
          }).then(() => onSuccess())
        }
        title={`Delete User ${fullName}`}
        body="Are you sure you want to delete? You can’t undo this action afterwards."
        successMessage="User is deleted successfully."
      >
        <MenuItem icon={<IoTrashOutline />}>Delete</MenuItem>
      </Modal.Confirm>
    </>
  );
};

export default Delete;
